import {
  PermissionExtensionAddDeactivationAction,
  PermissionExtensionRemoveDeactivationAction
} from 'app/auth/state/reducers/permissionExtension'
import { PERMISSION_EXTENSION_ADD_DEACTIVATION, PERMISSION_EXTENSION_REMOVE_DEACTIVATION } from 'app/auth/state/types'
import { PERMISSION_RMA_CREATE, PERMISSION_RMA_READ } from 'utils/Subscription/Permissions'

export const AddPermissionModificationRMA = (): PermissionExtensionAddDeactivationAction => {
  return {
    type: PERMISSION_EXTENSION_ADD_DEACTIVATION,
    payload: { permissions: [PERMISSION_RMA_CREATE, PERMISSION_RMA_READ] }
  }
}

export const RemovePermissionModificationRMA = (): PermissionExtensionRemoveDeactivationAction => {
  return {
    type: PERMISSION_EXTENSION_REMOVE_DEACTIVATION,
    payload: { permissions: [PERMISSION_RMA_CREATE, PERMISSION_RMA_READ] }
  }
}
